import React from 'react';
import Tab from '../webcommon/header/tab/Tab';
import { withRouter } from 'react-router';
import CsaDrilldown from './csadrilldown/CsaDrilldown';
import CsaSummary from './csasummary/CsaSummary';
import ImpactChart from './impactchart/ImpactChart';
import MonitoringSummary from './monitoringSummary/MonitoringSummary';
import styles from './Summary.module.scss';
import tabStyles from './TabOverride.module.scss';

const Summary = () => (
    <div className={ styles.summary }>
        <div className={ styles.header }>
            Summary
        </div>
        <div className={ styles.tabContainer }>
            <Tab
                rememberLastTab
                styles={ tabStyles }
                tabs={ [
                    {
                        title: 'CSA Drilldown',
                        path: '/csadrilldown',
                        component: CsaDrilldown
                    },
                    {
                        title: 'IM CSA Summary',
                        path: '/csasummary',
                        component: CsaSummary
                    },
                    {
                        title: 'IM CSA Charting',
                        path: '/impactchart',
                        component: () => <ImpactChart />
                    },
                    {
                        title: 'Monitoring IM CSA Summary',
                        path: '/monitoringsummary',
                        component: () => <MonitoringSummary />
                    }
                ] }
            />
        </div>
    </div>
);

export default withRouter(Summary);
